'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
export const COUPON_STATUS = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  REVEALED: 'REVEALED',
  DISMISSED: 'DISMISSED'
};

class CouponRevealedRecord extends Record({
  code: null,
  couponId: null,
  dismissedAt: null
}) {}

export default class CouponStateRecord extends Record({
  status: null,
  revealedCoupon: null,
  unavailableReason: null
}) {
  constructor(_ref) {
    let {
      revealedCoupon
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["revealedCoupon"]);

    super(Object.assign({}, rest, {
      revealedCoupon: revealedCoupon && new CouponRevealedRecord(revealedCoupon)
    }));
  }

}